import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function PaymentMethodSuccessPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const timer = setTimeout(() => {
            const redirectParam = searchParams.get("redirect");
            const storedUrl = sessionStorage.getItem("pendingPodcastUrl");

            if (redirectParam) {
                navigate(redirectParam, { replace: true });
                return;
            }

            if (storedUrl) {
                const encodedUrl = encodeURIComponent(storedUrl);
                navigate(`/podcasts/add?url=${encodedUrl}`, { replace: true });
                return;
            }

            navigate("/episodes", { replace: true });
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate, searchParams]);

    return (
        <div className={cn("min-h-screen flex items-center justify-center", theme.colors.backgroundCream)}>
            <div
                className={cn(
                    "max-w-md w-full mx-4 p-8 rounded-2xl text-center",
                    "bg-white dark:bg-gray-800",
                    theme.borders.neubrutalism,
                    theme.shadows.neubrutalism,
                )}
            >
                <div className="w-16 h-16 mx-auto mb-6 text-green-500 animate-bounce">
                    <CheckCircle2 className="w-full h-full" />
                </div>
                <h2 className="text-2xl font-black mb-4 text-gray-900 dark:text-white">Payment Method Updated!</h2>
                <p className="text-gray-600 dark:text-gray-300 mb-8">
                    Redirecting you back to your episodes...
                </p>
            </div>
        </div>
    );
}
